import useTheme from "../../hooks/ui/useTheme";
import { ThemeInterface } from "../../services/exports/Interfaces";

interface Props {
  className?: string;
  style?: Object;
  color?: string;
}

export default function OrderFromPhone(props: Props) {
  const { className, color, style } = props;
  const theme: ThemeInterface = useTheme();
  return (
    <svg
      className={className ?? "lg:h-40 lg:w-40 md:w-36 md:h-36 w-24 h-24"}
      viewBox="0 0 297 425"
      fill="none"
      style={style}
    >
      <path
        d="M296.322 424.413H182.244L172.781 398.956C169.427 389.939 162.569 382.689 153.797 378.722C145.535 374.988 134.416 368.205 123.638 356.118C102.663 332.592 91.5322 307.356 91.5322 307.356L162.23 307.009C162.23 307.009 155.867 267.494 191.005 215.015C194.759 209.392 196.483 202.658 195.891 195.924L192.56 157.649C192.56 157.649 168.682 130.985 183.331 97.9076C183.331 97.9076 197.339 78.5286 202.898 85.6216C202.898 85.6216 245.213 186.308 249.065 201.279C252.917 216.25 258.055 225.661 252.917 272.712C251.558 285.169 251.068 295.554 251.085 304.098C251.122 320.495 254.781 336.682 261.801 351.502L296.322 424.413Z"
        fill="#F8AE9D"
      />
      <path
        d="M21.7334 141.724C20.2642 141.214 18.8052 140.675 17.3574 140.106L17.7834 139.028C19.1784 139.577 20.6354 140.114 22.1144 140.63L21.7334 141.724Z"
        fill="#6A4B27"
      />
      <path
        d="M27.5926 33.1447C27.5926 33.1447 5.71864 18.5217 0.725638 28.1567C-4.26836 37.7897 29.1426 71.8767 29.1426 71.8767L27.5926 33.1447ZM27.5936 97.3237C27.5936 97.3237 5.71964 82.7027 0.725638 92.3357C-4.26736 101.969 29.1436 136.056 29.1436 136.056L27.5936 97.3237ZM27.5936 140.713C27.5936 140.713 5.71964 126.092 0.725638 135.725C-4.26736 145.358 29.1436 179.445 29.1436 179.445L27.5936 140.713Z"
        fill="#F8AE9D"
      />
      <path
        d="M44.4378 0.383789H177.087C186.965 0.383789 194.975 8.38379 194.975 18.2568V289.139C194.975 299.091 186.881 307.013 177.087 307.013H44.4378C34.5618 307.013 26.5498 299.015 26.5498 289.139V18.2548C26.5498 8.29478 34.6548 0.383789 44.4378 0.383789Z"
        fill="#111111"
      />
      <path
        d="M35.1094 24.8723H186.067V277.072H35.1094V24.8723ZM79.6144 16.6373H141.666C142.011 16.6373 142.341 16.5005 142.585 16.2569C142.829 16.0133 142.966 15.6829 142.966 15.3383V14.7023C142.966 14.3577 142.829 14.0273 142.585 13.7837C142.341 13.5401 142.011 13.4033 141.666 13.4033H79.6144C78.8974 13.4033 78.3144 13.9863 78.3144 14.7023V15.3383C78.3144 16.0543 78.8974 16.6373 79.6144 16.6373Z"
        fill="white"
      />
      <path
        d="M197.981 180.747C197.981 180.747 197.07 184.131 195.008 185.8L192.56 157.65C192.56 157.65 174.994 138.035 179.238 111.584C180.692 102.528 185.2 94.1949 192.092 88.1399C196.028 84.6829 200.351 82.3729 202.897 85.6259C202.897 85.6259 222.797 132.974 236.544 167.559L197.981 180.747Z"
        fill="#F8AE9D"
      />
      <path
        d="M104.713 291.534C104.713 293.212 105.38 294.822 106.566 296.009C107.753 297.195 109.363 297.862 111.041 297.862C112.719 297.862 114.329 297.195 115.515 296.009C116.702 294.822 117.369 293.212 117.369 291.534C117.369 289.856 116.702 288.246 115.515 287.059C114.329 285.873 112.719 285.206 111.041 285.206C109.363 285.206 107.753 285.873 106.566 287.059C105.38 288.246 104.713 289.856 104.713 291.534Z"
        fill="white"
      />
      <path
        d="M151.83 213H69.21C60.2575 213 53 220.257 53 229.21V235.58C53 244.533 60.2575 251.79 69.21 251.79H151.83C160.783 251.79 168.04 244.533 168.04 235.58V229.21C168.04 220.257 160.783 213 151.83 213Z"
        fill={color ?? theme.color.brand.inkGrey.grey_3}
      />
      <path
        d="M97.6307 231.727C97.6307 233.313 97.33 234.663 96.7287 235.776C96.1321 236.888 95.3177 237.738 94.2855 238.325C93.258 238.908 92.1027 239.199 90.8196 239.199C89.527 239.199 88.367 238.905 87.3395 238.318C86.312 237.731 85.5 236.881 84.9034 235.768C84.3068 234.656 84.0085 233.309 84.0085 231.727C84.0085 230.141 84.3068 228.792 84.9034 227.679C85.5 226.566 86.312 225.719 87.3395 225.136C88.367 224.549 89.527 224.256 90.8196 224.256C92.1027 224.256 93.258 224.549 94.2855 225.136C95.3177 225.719 96.1321 226.566 96.7287 227.679C97.33 228.792 97.6307 230.141 97.6307 231.727ZM94.5128 231.727C94.5128 230.7 94.3589 229.833 94.0511 229.128C93.7481 228.422 93.3196 227.887 92.7656 227.523C92.2116 227.158 91.563 226.976 90.8196 226.976C90.0762 226.976 89.4276 227.158 88.8736 227.523C88.3196 227.887 87.8887 228.422 87.581 229.128C87.2779 229.833 87.1264 230.7 87.1264 231.727C87.1264 232.755 87.2779 233.621 87.581 234.327C87.8887 235.032 88.3196 235.567 88.8736 235.932C89.4276 236.296 90.0762 236.479 90.8196 236.479C91.563 236.479 92.2116 236.296 92.7656 235.932C93.3196 235.567 93.7481 235.032 94.0511 234.327C94.3589 233.621 94.5128 232.755 94.5128 231.727ZM99.8519 239V228.091H102.785V229.994H102.899C103.098 229.317 103.431 228.806 103.9 228.46C104.369 228.11 104.909 227.935 105.52 227.935C105.671 227.935 105.834 227.944 106.01 227.963C106.185 227.982 106.339 228.008 106.471 228.041V230.726C106.329 230.683 106.133 230.645 105.882 230.612C105.631 230.579 105.401 230.562 105.193 230.562C104.748 230.562 104.35 230.66 104 230.854C103.654 231.043 103.379 231.308 103.176 231.649C102.977 231.99 102.877 232.383 102.877 232.828V239H99.8519ZM111.548 239.178C110.719 239.178 109.969 238.964 109.296 238.538C108.629 238.107 108.098 237.475 107.705 236.642C107.317 235.804 107.123 234.777 107.123 233.56C107.123 232.31 107.324 231.27 107.727 230.442C108.129 229.608 108.664 228.986 109.332 228.574C110.004 228.157 110.74 227.949 111.54 227.949C112.151 227.949 112.66 228.053 113.067 228.261C113.479 228.465 113.811 228.721 114.062 229.028C114.317 229.331 114.512 229.63 114.644 229.923H114.737V224.455H117.755V239H114.772V237.253H114.644C114.502 237.556 114.301 237.857 114.04 238.155C113.785 238.448 113.451 238.692 113.039 238.886C112.632 239.08 112.135 239.178 111.548 239.178ZM112.506 236.77C112.994 236.77 113.406 236.637 113.742 236.372C114.083 236.102 114.344 235.726 114.523 235.243C114.708 234.76 114.8 234.194 114.8 233.545C114.8 232.897 114.71 232.333 114.531 231.855C114.351 231.377 114.09 231.008 113.749 230.747C113.408 230.487 112.994 230.357 112.506 230.357C112.009 230.357 111.59 230.491 111.249 230.761C110.908 231.031 110.65 231.405 110.475 231.884C110.3 232.362 110.212 232.916 110.212 233.545C110.212 234.18 110.3 234.741 110.475 235.229C110.655 235.712 110.913 236.09 111.249 236.365C111.59 236.635 112.009 236.77 112.506 236.77ZM125.214 239.213C124.092 239.213 123.126 238.986 122.316 238.531C121.511 238.072 120.891 237.423 120.456 236.585C120.02 235.742 119.802 234.746 119.802 233.595C119.802 232.473 120.02 231.488 120.456 230.641C120.891 229.793 121.504 229.133 122.295 228.659C123.091 228.186 124.023 227.949 125.093 227.949C125.813 227.949 126.483 228.065 127.103 228.297C127.728 228.524 128.273 228.867 128.737 229.327C129.206 229.786 129.57 230.364 129.831 231.06C130.091 231.751 130.221 232.561 130.221 233.489V234.32H121.01V232.445H127.373C127.373 232.009 127.279 231.623 127.089 231.287C126.9 230.951 126.637 230.688 126.301 230.499C125.969 230.304 125.583 230.207 125.143 230.207C124.684 230.207 124.277 230.314 123.922 230.527C123.571 230.735 123.297 231.017 123.098 231.372C122.899 231.723 122.797 232.113 122.792 232.544V234.327C122.792 234.866 122.892 235.333 123.091 235.726C123.294 236.119 123.581 236.422 123.95 236.635C124.319 236.848 124.757 236.955 125.264 236.955C125.6 236.955 125.908 236.907 126.187 236.812C126.467 236.718 126.706 236.576 126.904 236.386C127.103 236.197 127.255 235.965 127.359 235.69L130.157 235.875C130.015 236.547 129.724 237.134 129.284 237.636C128.848 238.134 128.285 238.522 127.593 238.801C126.907 239.076 126.114 239.213 125.214 239.213ZM132.196 239V228.091H135.129V229.994H135.243C135.441 229.317 135.775 228.806 136.244 228.46C136.713 228.11 137.252 227.935 137.863 227.935C138.015 227.935 138.178 227.944 138.353 227.963C138.529 227.982 138.682 228.008 138.815 228.041V230.726C138.673 230.683 138.476 230.645 138.225 230.612C137.975 230.579 137.745 230.562 137.537 230.562C137.092 230.562 136.694 230.66 136.343 230.854C135.998 231.043 135.723 231.308 135.52 231.649C135.321 231.99 135.221 232.383 135.221 232.828V239H132.196Z"
        fill="white"
      />
      <g filter="url(#filter0_d_1636_1675)">
        <rect x="47" y="48" width="127" height="47" rx="5" fill="white" />
        <rect
          x="47.5"
          y="48.5"
          width="126"
          height="46"
          rx="4.5"
          stroke="#DAE9EF"
        />
      </g>
      <rect x="52" y="55" width="40" height="33" rx="5" fill="#DAE9EF" />
      <rect x="97" y="56" width="40" height="7" rx="2" fill="#DFECF1" />
      <rect x="97" y="68" width="30" height="7" rx="2" fill="#DAE9EF" />
      <rect
        x="153.5"
        y="56.5"
        width="14"
        height="15"
        rx="1.5"
        fill="white"
        stroke="#DAE9EF"
      />
      <rect
        x="160"
        y="60"
        width="1"
        height="7"
        fill={color ?? theme.color.brand.inkGrey.grey_3}
      />
      <rect
        width="1"
        height="7"
        transform="matrix(0 -1 -1 0 164 64)"
        fill={color ?? theme.color.brand.inkGrey.grey_3}
      />
      <g clipPath="url(#clip0_1636_1675)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M79.1324 68.0535H69.3668H66.8277L67.0332 69.0505C70.8337 69.3048 73.6352 70.9364 75.0105 72.5254C75.5395 73.1357 75.9097 73.7888 76.103 74.4256C76.3858 75.3574 76.3167 76.2648 75.8731 77.0623C75.8162 77.1661 75.7531 77.2658 75.686 77.3634C75.7694 77.5425 75.8324 77.7215 75.8833 77.8945C75.8996 77.9412 75.9159 77.9901 75.9281 78.0389H75.9301C75.9952 78.2688 76.0278 78.4926 76.0278 78.7144C76.0278 78.7917 76.0237 78.7673 76.0196 78.8344L76.0216 78.8893H76.0278C76.0278 78.8527 76.0278 78.8303 76.0278 78.8893C76.0278 78.9463 76.0257 79.0053 76.0216 79.0643H79.1202L81.6735 68.0576H79.1324V68.0535ZM58.649 81.1517C63.5094 81.1436 68.3678 81.1375 73.2283 81.1517C73.5172 81.1537 73.7552 81.3897 73.7552 81.6786C73.7552 82.4639 73.4256 84.002 71.6495 84.002C67.8429 84.002 64.0364 84.002 60.2298 84.002C58.4537 84.002 58.1241 82.466 58.1241 81.6786C58.1221 81.3877 58.3601 81.1517 58.649 81.1517ZM69.5336 73.0523C69.9812 73.0523 70.3433 73.4145 70.3433 73.8621C70.3433 74.3097 69.9812 74.6718 69.5336 74.6718C69.086 74.6718 68.7239 74.3097 68.7239 73.8621C68.7239 73.4145 69.086 73.0523 69.5336 73.0523ZM62.4718 73.1093C62.9194 73.1093 63.2816 73.4714 63.2816 73.919C63.2816 74.3666 62.9194 74.7288 62.4718 74.7288C62.0243 74.7288 61.6621 74.3666 61.6621 73.919C61.6621 73.4714 62.0243 73.1093 62.4718 73.1093ZM65.9732 72.3362C66.4208 72.3362 66.783 72.6983 66.783 73.1459C66.783 73.5935 66.4208 73.9556 65.9732 73.9556C65.5256 73.9556 65.1635 73.5935 65.1635 73.1459C65.1655 72.6983 65.5277 72.3362 65.9732 72.3362ZM72.5406 76.5252H59.5076C58.6795 76.5252 58 75.8477 58 75.0197C58 72.8753 62.2745 71.3169 65.8613 71.2803C72.9231 71.2091 76.0908 76.5252 72.5406 76.5252ZM73.7206 78.5903C73.743 78.6289 73.7552 78.6676 73.7552 78.7123C73.7552 78.7388 73.7532 78.7693 73.7532 78.7998C73.7552 78.8303 73.7552 78.8588 73.7552 78.8873C73.7552 78.93 73.743 78.9707 73.7206 79.0094C73.6006 79.5322 73.1204 80.2158 71.6495 80.2158C67.8429 80.2158 64.0364 80.2158 60.2298 80.2158C58.7568 80.2158 58.2787 79.5322 58.1587 79.0094C58.1363 78.9707 58.1241 78.932 58.1241 78.8873C58.1241 78.8608 58.1261 78.8303 58.1261 78.7998C58.1241 78.7693 58.1241 78.7408 58.1241 78.7123C58.1241 78.6696 58.1363 78.6289 58.1587 78.5903C58.2787 78.0674 58.7568 77.3838 60.2298 77.3838H66.1441L68.3251 79.636L70.4919 77.3838H71.6515C73.1225 77.3858 73.6006 78.0694 73.7206 78.5903ZM76.0196 78.8873C76.0237 79.0643 76.0257 78.9524 76.0257 78.8873H76.0196ZM66.846 63.5369H73.2364L73.9322 60.4445C74.1336 59.6978 74.7196 59.2808 75.7531 59C76.63 59 77.5068 59 78.3817 59C78.7825 59.0793 79.0144 59.3581 79.0754 59.8382C79.0754 60.1088 79.0754 60.3774 79.0754 60.6479C78.9432 61.0894 78.6767 61.2685 78.2657 61.3417H76.0725L75.6066 63.5369H81.6532C82.1618 63.5369 82.5748 63.952 82.5748 64.4586V65.5063C82.5748 66.015 82.1598 66.428 81.6532 66.428H66.846C66.3374 66.428 65.9244 66.0129 65.9244 65.5063V64.4586C65.9244 63.952 66.3394 63.5369 66.846 63.5369ZM75.5741 83.7986H76.6747H77.3095C78.0501 83.6399 78.5648 83.29 78.7825 82.5555L78.9493 80.8099H75.8874C75.9789 81.0846 76.0278 81.3755 76.0278 81.6786C76.0278 82.2402 75.924 83.0275 75.5741 83.7986Z"
          fill={color ?? theme.color.brand.inkGrey.grey_3}
        />
      </g>
      <g filter="url(#filter1_d_1636_1675)">
        <rect x="47" y="107" width="127" height="47" rx="5" fill="white" />
        <rect
          x="47.5"
          y="107.5"
          width="126"
          height="46"
          rx="4.5"
          stroke="#DAE9EF"
        />
      </g>
      <rect x="52" y="114" width="40" height="33" rx="5" fill="#DAE9EF" />
      <rect x="97" y="115" width="40" height="7" rx="2" fill="#DFECF1" />
      <rect x="97" y="127" width="30" height="7" rx="2" fill="#DAE9EF" />
      <rect
        x="153.5"
        y="115.5"
        width="14"
        height="15"
        rx="1.5"
        fill="white"
        stroke="#DAE9EF"
      />
      <rect
        x="160"
        y="119"
        width="1"
        height="7"
        fill={color ?? theme.color.brand.inkGrey.grey_3}
      />
      <rect
        width="1"
        height="7"
        transform="matrix(0 -1 -1 0 164 123)"
        fill={color ?? theme.color.brand.inkGrey.grey_3}
      />
      <g clip-path="url(#clip1_1636_1675)">
        <path
          d="M66.5656 127.747C70.3397 130.652 71.6865 129.507 73.8471 128.441C75.5032 127.627 76.1522 126.852 78.1644 127.668V124.714H66.5677V127.747H66.5656ZM61.7581 119.757C62.8846 118.632 64.4118 118 66.0041 118C67.5964 118 69.1236 118.632 70.2501 119.757C70.301 119.808 70.3519 119.861 70.4007 119.914L70.5573 120.036L66.9502 123.645H73.9794L74.7932 120.901C74.8174 120.802 74.8632 120.709 74.9271 120.63C74.9911 120.55 75.0718 120.486 75.1635 120.441L78.6079 118.508C78.7698 118.418 78.9609 118.396 79.1393 118.446C79.2276 118.471 79.3101 118.513 79.3821 118.57C79.4542 118.627 79.5143 118.698 79.559 118.778C79.6038 118.858 79.6323 118.946 79.643 119.037C79.6536 119.129 79.6462 119.221 79.6212 119.309C79.5962 119.398 79.554 119.48 79.4971 119.552C79.4402 119.624 79.3696 119.684 79.2894 119.729L76.0871 121.521L75.4157 123.645H78.7177C78.8356 123.645 78.9486 123.692 79.0321 123.775C79.1156 123.858 79.1628 123.971 79.1633 124.089V129.749C79.1633 133.425 77.1532 136.278 73.4036 136.558V141.73H76.3231C76.5693 141.73 76.7667 142.121 76.7667 142.365C76.7667 142.609 76.5632 143 76.3231 143H68.9765C68.7304 143 68.533 142.609 68.533 142.365C68.533 142.121 68.7365 141.73 68.9765 141.73H71.5278V136.577C67.6622 136.418 65.5036 133.525 65.5036 129.751V125.09L62.0572 128.538L61.9962 128.459C61.9188 128.388 61.8415 128.317 61.7663 128.241C60.6409 127.115 60.0088 125.588 60.0088 123.995C60.0088 122.403 60.6409 120.876 61.7663 119.749L61.7581 119.757ZM69.3082 119.981C68.3094 119.162 67.0418 118.744 65.7518 118.808C64.4618 118.871 63.2415 119.412 62.3282 120.326C61.4149 121.239 60.8739 122.459 60.8102 123.749C60.7466 125.039 61.165 126.307 61.9839 127.305L62.3644 126.925C61.6695 126.025 61.3265 124.902 61.3993 123.767C61.4722 122.632 61.956 121.562 62.7603 120.758C63.5645 119.953 64.6342 119.469 65.7693 119.397C66.9044 119.324 68.0272 119.667 68.9277 120.362L69.3082 119.981ZM62.93 126.359L64.8831 124.402H62.1528C62.2257 125.114 62.4948 125.792 62.93 126.359ZM66.4029 122.882L68.3601 120.925C67.7922 120.49 67.1146 120.221 66.4029 120.148V122.882ZM62.1528 123.605H65.0398L63.0053 121.57C62.5317 122.152 62.2377 122.859 62.1589 123.605H62.1528ZM65.6115 123.039V120.152C64.8655 120.231 64.1587 120.525 63.577 120.999L65.6115 123.033V123.039Z"
          fill={color ?? theme.color.brand.inkGrey.grey_3}
        />
      </g>
      <defs>
        <filter
          id="filter0_d_1636_1675"
          x="43"
          y="48"
          width="135"
          height="55"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1636_1675"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1636_1675"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_1636_1675"
          x="43"
          y="107"
          width="135"
          height="55"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1636_1675"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1636_1675"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_1636_1675">
          <rect
            width="24.5748"
            height="25"
            fill="white"
            transform="translate(58 59)"
          />
        </clipPath>
        <clipPath id="clip1_1636_1675">
          <rect
            width="19.6452"
            height="25"
            fill="white"
            transform="translate(60 118)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
